import { createFileRoute } from '@tanstack/react-router'
import { RelatorioCrmAtestados } from '@/features/relatorios-crm-atestados'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/crm-atestados/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioCrmAtestados,
})
